import { createSelector } from 'reselect'
import * as SelectorUtils from './utils'

import { DefaultState } from '../reducers/DefaultState'

const getGlobalAttentionIndexState = (state) => {
    return (state || {}).globalAttentionIndex
}

const getSelectedDate = createSelector (
    [getGlobalAttentionIndexState],
    (state) => {
        return (state || {}).selectedDate
    }
)

const getAnticipationIndexDetailsState = createSelector (
    [getGlobalAttentionIndexState, getSelectedDate],
    (state, selectedDate) => {
        return (state || {}).anticipationViewDetails && (state || {}).anticipationViewDetails[selectedDate] || DefaultState
    }
)

const getTopContentIndexDetailsState = createSelector (
    [getGlobalAttentionIndexState, getSelectedDate],
    (state, selectedDate) => {
        return (state || {}).topContentViewDetails && (state || {}).topContentViewDetails[selectedDate] || DefaultState
    }
)

const getTrendingIndexDetailsState = createSelector (
    [getGlobalAttentionIndexState, getSelectedDate],
    (state, selectedDate) => {
        return (state || {}).trendingViewDetails && (state || {}).trendingViewDetails[selectedDate] || DefaultState
    }
)

const getCancelledShowsIndexDetailsState = createSelector (
    [getGlobalAttentionIndexState, getSelectedDate],
    (state, selectedDate) => {
        return (state || {}).cancelledShowsDetails && (state || {}).cancelledShowsDetails[selectedDate] || DefaultState
    }
)

const makeAnticipationIndexDetailsSelector = () => {
    return createSelector (
      [getAnticipationIndexDetailsState],
      (details) => {
        if (details) {
          return {
            isFetching: SelectorUtils.isFetching(details),
            error: details.error,
            details: details.details
          }
        }
      }
    )
}

const makeTopContentIndexDetailsSelector = () => {
    return createSelector (
      [getTopContentIndexDetailsState],
      (details) => {
        if (details) {
          return {
            isFetching: SelectorUtils.isFetching(details),
            error: details.error,
            details: details.details
          }
        }
      }
    )
}

const makeTrendingIndexDetailsSelector = () => {
    return createSelector (
      [getTrendingIndexDetailsState],
      (details) => {
        if (details) {
          return {
            isFetching: SelectorUtils.isFetching(details),
            error: details.error,
            details: details.details
          }
        }
      }
    )
}

const makeCancelledShowsIndexDetailsSelector = () => {
    return createSelector (
      [getCancelledShowsIndexDetailsState],
      (details) => {
        if (details) {
          return {
            isFetching: SelectorUtils.isFetching(details),
            error: details.error,
            details: details.details
          }
        }
      }
    )
}

export {
  makeAnticipationIndexDetailsSelector,
  makeTopContentIndexDetailsSelector,
  makeTrendingIndexDetailsSelector,
  makeCancelledShowsIndexDetailsSelector
}